import { useContext } from 'react';

// Context
import { ContextArticle } from '../context/ArticleContext';

export const useArticle = () => useContext(ContextArticle);
